import { render, staticRenderFns } from "./KpiPanel.vue?vue&type=template&id=04ddc661"
import script from "./KpiPanel.vue?vue&type=script&lang=ts"
export * from "./KpiPanel.vue?vue&type=script&lang=ts"
import style0 from "./KpiPanel.vue?vue&type=style&index=0&id=04ddc661&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports